import React from "react";
import usePageTitle from "../hooks/usePageTitle";
import { useTranslation } from "react-i18next";
import "./LegalPage.css";

function TermsPage() {
  const { t } = useTranslation();
  usePageTitle(t("terms.pageTitle"));

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <span className="last-updated">{t("terms.lastUpdated")}</span>
          <h1 className="legal-title">{t("terms.heroTitle")}</h1>
          <p className="legal-subtitle">{t("terms.heroSubtitle")}</p>
        </div>
      </div>

      <div className="container">
        <div className="legal-content">
          <section className="legal-section">
            <h2>{t("terms.s1Title")}</h2>
            <p>{t("terms.s1Content")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("terms.s2Title")}</h2>
            <p>{t("terms.s2Content")}</p>
            <ul>
              <li>{t("terms.s2Item1")}</li>
              <li>{t("terms.s2Item2")}</li>
              <li>{t("terms.s2Item3")}</li>
              <li>{t("terms.s2Item4")}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t("terms.s3Title")}</h2>
            <p>{t("terms.s3Content")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("terms.s4Title")}</h2>
            <p>{t("terms.s4Content")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("terms.s5Title")}</h2>
            <p>{t("terms.s5Content")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("terms.s6Title")}</h2>
            <p>{t("terms.s6ContentPrefix")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("terms.s7Title")}</h2>
            <p>{t("terms.s7Content")}</p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
